import { Injectable } from '@angular/core'

@Injectable()
export class UtilsService {
  constructor() {}

  getParameterByName(name, url?) {
    if (!url) {
      url = window.location.href
    }
    name = name.replace(/[\[\]]/g, '\\$&')
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url)
    if (!results) {
      return null
    }
    if (!results[2]) {
      return ''
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '))
  }

  updateQueryString(key, value, url) {
    if (!url) {
      url = window.location.href
    }
    let re = new RegExp('([?&])' + key + '=.*?(&|#|$)(.*)', 'gi'),
      hash

    if (re.test(url)) {
      if (typeof value !== 'undefined' && value !== null) {
        return url.replace(re, '$1' + key + '=' + value + '$2$3')
      } else {
        hash = url.split('#')
        url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '')
        if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
          url += '#' + hash[1]
        }
        return url
      }
    } else {
      if (typeof value !== 'undefined' && value !== null) {
        const separator = url.indexOf('?') !== -1 ? '&' : '?'
        hash = url.split('#')
        url = hash[0] + separator + key + '=' + value
        if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
          url += '#' + hash[1]
        }
        return url
      } else {
        return url
      }
    }
  }

  addQueryParams(url, queryParams) {
    let newUrl = url

    if (!queryParams.length) {
      return newUrl
    }

    queryParams.forEach(p => {
      newUrl = this.updateQueryString(p.key, p.value, newUrl)
    })

    return newUrl

    const paramsAsStrings = queryParams.map(keyValue => {
      return keyValue.key + '=' + keyValue.value
    })

    const resultString = paramsAsStrings.join('&')

    if (newUrl.indexOf('?') > -1) {
      return newUrl + '&' + resultString
    } else {
      return newUrl + '?' + resultString
    }
    /*
        if (!!window.location.search && baseUrl.indexOf('?') > 0) {
          return baseUrl + '&' + resultString;
        } else {
          return baseUrl + '?' + resultString;
        }*/
  }

  transformObjInQueryParams(obj: object) {
    const queryParams = []

    for (const key in obj) {
      if (Array.isArray(obj[key])) {
        obj[key].forEach(el => {
          queryParams.push(key + '=' + el)
        })
      } else {
        queryParams.push(key + '=' + obj[key])
      }
    }

    return queryParams.join('&')
  }

  // https://www.html-code-generator.com/javascript/shorten-long-numbers
  intToString(num: number) {
    if (num < 1000) {
      return num
    }
    const si = [
      { v: 1e3, s: 'K' },
      { v: 1e6, s: 'M' },
      { v: 1e9, s: 'B' },
      { v: 1e12, s: 'T' },
      { v: 1e15, s: 'P' },
      { v: 1e18, s: 'E' }
    ]
    let i
    for (i = si.length - 1; i > 0; i--) {
      if (num >= si[i].v) {
        break
      }
    }
    return (num / si[i].v).toFixed(2).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].s
  }
}
